import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-int.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/equipmentLive/nothing.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2c16325e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "device-detail"
};
var _hoisted_2 = {
  class: "box"
};
var _hoisted_3 = {
  class: "box realTimeParams"
};
var _hoisted_4 = {
  class: "label"
};
var _hoisted_5 = {
  class: "value"
};
var _hoisted_6 = {
  class: "label"
};
var _hoisted_7 = {
  class: "red"
};
var _hoisted_8 = {
  class: "box"
};
var _hoisted_9 = {
  key: 0,
  class: "box openTimeRange"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "titleInfo"
  }, "近三日数据", -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "openBlock"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "mr-4"
  }, "开机"), /*#__PURE__*/_createElementVNode("div", {
    class: "closeBlock"
  }), /*#__PURE__*/_createElementVNode("span", null, "关机")], -1);
});
var _hoisted_12 = {
  class: "chart flex align-center"
};
var _hoisted_13 = {
  class: "flex align-center justify-between"
};
var _hoisted_14 = {
  class: "text"
};
var _hoisted_15 = {
  class: "text"
};
var _hoisted_16 = {
  class: "box"
};
var _hoisted_17 = {
  class: "myTitle"
};
var _hoisted_18 = {
  key: 0
};
var _hoisted_19 = {
  class: "row"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "保养内容", -1);
});
var _hoisted_21 = {
  class: "b"
};
var _hoisted_22 = {
  class: "row"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "保养人员", -1);
});
var _hoisted_24 = {
  class: "b"
};
var _hoisted_25 = {
  class: "row"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "保养时间", -1);
});
var _hoisted_27 = {
  class: "b"
};
var _hoisted_28 = {
  class: "row"
};
var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "备注信息", -1);
});
var _hoisted_30 = {
  class: "b"
};
var _hoisted_31 = {
  class: "row"
};
var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "下次时间", -1);
});
var _hoisted_33 = {
  class: "b"
};
var _hoisted_34 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1);
});
var _hoisted_35 = {
  key: 1,
  class: "nothing"
};
var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1);
});
var _hoisted_38 = [_hoisted_36, _hoisted_37];
var _hoisted_39 = {
  class: "box"
};
var _hoisted_40 = {
  class: "myTitle"
};
var _hoisted_41 = {
  key: 0
};
var _hoisted_42 = {
  class: "row"
};
var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "维修内容", -1);
});
var _hoisted_44 = {
  class: "b"
};
var _hoisted_45 = {
  class: "row"
};
var _hoisted_46 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "维修结果", -1);
});
var _hoisted_47 = {
  class: "b"
};
var _hoisted_48 = {
  class: "row"
};
var _hoisted_49 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "维修人员", -1);
});
var _hoisted_50 = {
  class: "b"
};
var _hoisted_51 = {
  class: "row"
};
var _hoisted_52 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "维修时间", -1);
});
var _hoisted_53 = {
  class: "b"
};
var _hoisted_54 = {
  class: "row"
};
var _hoisted_55 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "备注信息", -1);
});
var _hoisted_56 = {
  class: "b"
};
var _hoisted_57 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1);
});
var _hoisted_58 = {
  key: 1,
  class: "nothing"
};
var _hoisted_59 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_60 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1);
});
var _hoisted_61 = [_hoisted_59, _hoisted_60];
var _hoisted_62 = {
  class: "box"
};
var _hoisted_63 = {
  class: "myTitle"
};
var _hoisted_64 = {
  key: 0
};
var _hoisted_65 = {
  class: "row"
};
var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "点检记录", -1);
});
var _hoisted_67 = {
  class: "b"
};
var _hoisted_68 = {
  class: "row"
};
var _hoisted_69 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "点检结果", -1);
});
var _hoisted_70 = {
  class: "b"
};
var _hoisted_71 = {
  class: "row"
};
var _hoisted_72 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "点检人员", -1);
});
var _hoisted_73 = {
  class: "b"
};
var _hoisted_74 = {
  class: "row"
};
var _hoisted_75 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "点检时间", -1);
});
var _hoisted_76 = {
  class: "b"
};
var _hoisted_77 = {
  class: "row"
};
var _hoisted_78 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "a"
  }, "备注信息", -1);
});
var _hoisted_79 = {
  class: "b"
};
var _hoisted_80 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1);
});
var _hoisted_81 = {
  key: 1,
  class: "nothing"
};
var _hoisted_82 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_83 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1);
});
var _hoisted_84 = [_hoisted_82, _hoisted_83];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$maintainRecord$r, _ctx$repairRecord$rem, _ctx$pointRecord$rema, _ctx$pointRecord$rema2, _ctx$pointRecord$rema3;
  var _component_fixed_info = _resolveComponent("fixed-info");
  var _component_c_title = _resolveComponent("c-title");
  var _component_c_date_select = _resolveComponent("c-date-select");
  var _component_current_select = _resolveComponent("current-select");
  var _component_line_echart = _resolveComponent("line-echart");
  var _component_van_button = _resolveComponent("van-button");
  var _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_fixed_info, {
    deviceInfo: _ctx.deviceInfo,
    id: _ctx.id
  }, null, 8, ["deviceInfo", "id"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_c_title, {
    title: "实时参数"
  }), !_ctx.tmpShow ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.newClassReal, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "realTimeParamsItem",
      key: item.name
    }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.value), 1)]);
  }), 128)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceTemperList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "realTimeParamsItem",
      key: item.text
    }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.text), 1), _createElementVNode("div", {
      class: _normalizeClass(["value", {
        red: item.value === item.variableThreshold,
        yellow: parseInt(item.value) / parseInt(item.variableThreshold) >= 0.9
      }])
    }, [_createTextVNode(_toDisplayString(item.value) + " ", 1), _createElementVNode("span", _hoisted_7, "(报警：" + _toDisplayString(item.variableThreshold) + ")", 1)], 2)]);
  }), 128))]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_c_title, {
    title: "历史曲线"
  }), _createVNode(_component_c_date_select, {
    backgroundColor: "#F6F7F8",
    class: "mb-3",
    onConfirmDate: _ctx.confirmDate
  }, null, 8, ["onConfirmDate"]), _createVNode(_component_current_select, {
    columns: _ctx.deviceTemperList,
    onConfirmCurrent: _ctx.confirmCurrent
  }, null, 8, ["columns", "onConfirmCurrent"]), _createVNode(_component_line_echart, _normalizeProps(_guardReactiveProps(_ctx.saleTrend)), null, 16)]), !_ctx.tmpShow ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_c_title, {
    title: "开机时间段"
  }, {
    info: _withCtx(function () {
      return [_hoisted_10];
    }),
    _: 1
  }), _hoisted_11, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openCloseList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "openCloseChart",
      key: index
    }, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.runTimeList, function (iten, indey) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["point", {
          blue: iten.status === '1',
          grey: iten.status === '0'
        }]),
        style: _normalizeStyle({
          width: "".concat(Number(iten.value), "%")
        }),
        key: indey
      }, null, 6);
    }), 128))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(item.startTime), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(item.endTime), 1)])]);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_c_title, {
    title: "保养记录"
  }), _createVNode(_component_van_button, {
    type: "default",
    style: {
      "color": "#4372f6"
    },
    size: "small",
    plain: "",
    hairline: "",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.changeMachineState(1);
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("新增")];
    }),
    _: 1
  })]), _ctx.maintainRecord ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.maintainRecord.info), 1)]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.maintainRecord.person), 1)]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.maintainRecord.maintain_time), 1)]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, _toDisplayString((_ctx$maintainRecord$r = _ctx.maintainRecord.remark) !== null && _ctx$maintainRecord$r !== void 0 ? _ctx$maintainRecord$r : '-'), 1)]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.maintainRecord.next_time), 1)]), _createElementVNode("div", {
    class: "more",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.changeMachineState(0);
    })
  }, [_createVNode(_component_van_icon, {
    name: "orders-o",
    size: "16"
  }), _hoisted_34])])) : (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_c_title, {
    title: "维修记录"
  }), _createVNode(_component_van_button, {
    type: "default",
    style: {
      "color": "#4372f6"
    },
    size: "small",
    plain: "",
    hairline: "",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.changeRepairState(1);
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("新增")];
    }),
    _: 1
  })]), _ctx.repairRecord ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.repairRecord.repair_info), 1)]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.repairRecord.check_point_result), 1)]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.repairRecord.check_persion), 1)]), _createElementVNode("div", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.repairRecord.create_time), 1)]), _createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, _toDisplayString((_ctx$repairRecord$rem = _ctx.repairRecord.remark) !== null && _ctx$repairRecord$rem !== void 0 ? _ctx$repairRecord$rem : '-'), 1)]), _createElementVNode("div", {
    class: "more",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.changeRepairState(0);
    })
  }, [_createVNode(_component_van_icon, {
    name: "orders-o",
    size: "16"
  }), _hoisted_57])])) : (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61))]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createVNode(_component_c_title, {
    title: "点检记录"
  }), _createVNode(_component_van_button, {
    type: "default",
    style: {
      "color": "#4372f6"
    },
    size: "small",
    plain: "",
    hairline: "",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.changePointRepairState(1);
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("新增")];
    }),
    _: 1
  })]), _ctx.pointRecord ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_hoisted_66, _createElementVNode("div", _hoisted_67, _toDisplayString((_ctx$pointRecord$rema = _ctx.pointRecord.remark) === null || _ctx$pointRecord$rema === void 0 ? void 0 : _ctx$pointRecord$rema.a), 1)]), _createElementVNode("div", _hoisted_68, [_hoisted_69, _createElementVNode("div", _hoisted_70, _toDisplayString((_ctx$pointRecord$rema2 = _ctx.pointRecord.remark) === null || _ctx$pointRecord$rema2 === void 0 ? void 0 : _ctx$pointRecord$rema2.b), 1)]), _createElementVNode("div", _hoisted_71, [_hoisted_72, _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.pointRecord.check_persion), 1)]), _createElementVNode("div", _hoisted_74, [_hoisted_75, _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.pointRecord.create_time), 1)]), _createElementVNode("div", _hoisted_77, [_hoisted_78, _createElementVNode("div", _hoisted_79, _toDisplayString((_ctx$pointRecord$rema3 = _ctx.pointRecord.remark) === null || _ctx$pointRecord$rema3 === void 0 ? void 0 : _ctx$pointRecord$rema3.c), 1)]), _createElementVNode("div", {
    class: "more",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.changePointRepairState(0);
    })
  }, [_createVNode(_component_van_icon, {
    name: "orders-o",
    size: "16"
  }), _hoisted_80])])) : (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_84))])]);
}